import { createContext } from 'react';

export const VersionControlContext = createContext<null>(null);
